import { SavingsBanner } from "@swiggy-private/cart-types";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "../constants";

export const impressionSavingsBanner = (
    offerText: SavingsBanner,
    offerName: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_SAVINGS,
        label: JSON.stringify(offerText),
        context: offerName,
    });
};

export const impressionSavingsBannerOneLine = (
    offerText: SavingsBanner,
    offerName: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    extraParams?: Record<string, string>,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_SAVINGS_ONE_LINE,
        label: JSON.stringify(offerText),
        context: offerName,
        extraParams: JSON.stringify(extraParams ?? {}),
    });
};

export const clickAvailOffersCoupon = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_AVAIL_OFFERS_COUPONS,
    });
};
